var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContractHistoryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16V19L19 20",
    stroke: "#0E0D0A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 5.33301H23.9997C24.7069 5.33301 25.3852 5.61396 25.8853 6.11406C26.3854 6.61415 26.6663 7.29243 26.6663 7.99967V26.6663C26.6663 27.3736 26.3854 28.0519 25.8853 28.552C25.3852 29.0521 24.7069 29.333 23.9997 29.333H7.99967C7.29243 29.333 6.61415 29.0521 6.11406 28.552C5.61396 28.0519 5.33301 27.3736 5.33301 26.6663V7.99967C5.33301 7.29243 5.61396 6.61415 6.11406 6.11406C6.61415 5.61396 7.29243 5.33301 7.99967 5.33301H10.6663",
    stroke: "#0E0D0A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 2.66699H12.0003C11.2639 2.66699 10.667 3.26395 10.667 4.00033V6.66699C10.667 7.40337 11.2639 8.00033 12.0003 8.00033H20.0003C20.7367 8.00033 21.3337 7.40337 21.3337 6.66699V4.00033C21.3337 3.26395 20.7367 2.66699 20.0003 2.66699Z",
    stroke: "#0E0D0A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13V16H12",
    stroke: "#0E0D0A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88281 20.6599C10.3691 21.9891 11.2909 23.13 12.5092 23.9109C13.7276 24.6918 15.1764 25.0702 16.6376 24.9893C18.0987 24.9083 19.4929 24.3723 20.6102 23.462C21.7274 22.5517 22.5071 21.3164 22.8319 19.9423C23.1566 18.5682 23.0088 17.1297 22.4107 15.8435C21.8125 14.5573 20.7965 13.4932 19.5156 12.8114C18.2348 12.1296 16.7585 11.8671 15.3092 12.0634C13.8599 12.2597 12.5162 12.9043 11.4804 13.8999L9.5 15.8435",
    stroke: "#0E0D0A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractHistoryIcon);
export default __webpack_public_path__ + "static/media/contract_history_icon.3d3bfcd0bcf89ca05e2c69a970b69102.svg";
export { ForwardRef as ReactComponent };